var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticStyle: { "min-height": "0" }, attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("span", { staticClass: "text-subtitle-1" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("consents.identifier_type." + _vm.identifier.type)
                    ) +
                    " :\n        "
                ),
                _c("b", [_vm._v(_vm._s(_vm.identifier.value))]),
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ml-2",
                  attrs: {
                    small: "",
                    text: "",
                    color: "primary",
                    to: { name: "consents_search" },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("consents.new_search")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.error
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-alert", { attrs: { type: "error", dense: "" } }, [
                    _vm._v(_vm._s(_vm.error)),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.result
        ? [
            _vm.result.people.length === 0
              ? _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", "data-cy": "consent-nobody" } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "consents.empty_person." + _vm.identifier.type
                            )
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-chip-group",
                            {
                              attrs: {
                                multiple: "",
                                column: "",
                                "active-class": "primary--text",
                                "data-cy": "consent-channel-filter",
                              },
                              model: {
                                value: _vm.selectedChannels,
                                callback: function ($$v) {
                                  _vm.selectedChannels = $$v
                                },
                                expression: "selectedChannels",
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "text-caption mr-2 mt-2" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("consents.channel_filter"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.channels, function (channel) {
                                return _c(
                                  "v-chip",
                                  {
                                    key: channel,
                                    attrs: {
                                      value: channel,
                                      filter: "",
                                      outlined: "",
                                      small: "",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("consents.channel." + channel)
                                      )
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.result.people, function (person, personIndex) {
                    return _c(
                      "v-row",
                      { key: personIndex },
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12" } },
                          [
                            _c(
                              "v-card",
                              { attrs: { "data-cy": "consent-person" } },
                              [
                                _c(
                                  "v-card-title",
                                  { staticClass: "text-subtitle-1" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "consents.person.current_state"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                    _vm.result.people.length > 1
                                      ? _c(
                                          "span",
                                          { staticClass: "text-caption ml-2" },
                                          [
                                            _vm._v(
                                              "(" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "consents.person.number",
                                                    {
                                                      number: personIndex + 1,
                                                      total:
                                                        _vm.result.people
                                                          .length,
                                                    }
                                                  )
                                                ) +
                                                ")"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-card-text",
                                  [
                                    _c("v-simple-table", {
                                      attrs: {
                                        dense: "",
                                        "data-cy": "consent-grid",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function () {
                                              return [
                                                _c("thead", [
                                                  _c(
                                                    "tr",
                                                    [
                                                      _c("th", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "consents.person.advertiser"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.visibleChannels,
                                                        function (channel) {
                                                          return _c(
                                                            "th",
                                                            {
                                                              key: channel,
                                                              staticClass:
                                                                "text-center",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "consents.channel." +
                                                                        channel
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "tbody",
                                                  _vm._l(
                                                    _vm.result.advertisers,
                                                    function (
                                                      advertiser,
                                                      advertiserIndex
                                                    ) {
                                                      return _c(
                                                        "tr",
                                                        { key: advertiser.id },
                                                        [
                                                          _c(
                                                            "td",
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    advertiser.name ||
                                                                      "#" +
                                                                        advertiser.id
                                                                  ) +
                                                                  "\n                        "
                                                              ),
                                                              _vm.brandRequirement(
                                                                advertiser,
                                                                advertiserIndex
                                                              )
                                                                ? _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        top: "",
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "activator",
                                                                              fn: function (
                                                                                ref
                                                                              ) {
                                                                                var on =
                                                                                  ref.on
                                                                                var attrs =
                                                                                  ref.attrs
                                                                                return [
                                                                                  "mandatory" ===
                                                                                  _vm.brandRequirement(
                                                                                    advertiser,
                                                                                    advertiserIndex
                                                                                  )
                                                                                    ? _c(
                                                                                        "v-chip",
                                                                                        _vm._g(
                                                                                          _vm._b(
                                                                                            {
                                                                                              staticClass:
                                                                                                "ml-1",
                                                                                              attrs:
                                                                                                {
                                                                                                  "x-small":
                                                                                                    "",
                                                                                                  outlined:
                                                                                                    "",
                                                                                                  color:
                                                                                                    "primary",
                                                                                                  "data-cy":
                                                                                                    "consent-brand-mandatory-" +
                                                                                                    advertiser.id,
                                                                                                },
                                                                                            },
                                                                                            "v-chip",
                                                                                            attrs,
                                                                                            false
                                                                                          ),
                                                                                          on
                                                                                        ),
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              _vm.$t(
                                                                                                "consents.person.mandatory"
                                                                                              )
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _c(
                                                                                        "span",
                                                                                        _vm._g(
                                                                                          _vm._b(
                                                                                            {
                                                                                              staticClass:
                                                                                                "text-caption grey--text ml-1",
                                                                                              attrs:
                                                                                                {
                                                                                                  "data-cy":
                                                                                                    "consent-brand-optional-" +
                                                                                                    advertiser.id,
                                                                                                },
                                                                                            },
                                                                                            "span",
                                                                                            attrs,
                                                                                            false
                                                                                          ),
                                                                                          on
                                                                                        ),
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              _vm.$t(
                                                                                                "consents.person.optional"
                                                                                              )
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "consents.person." +
                                                                                  _vm.brandRequirement(
                                                                                    advertiser,
                                                                                    advertiserIndex
                                                                                  ) +
                                                                                  "_detail"
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _vm._l(
                                                            _vm.visibleChannels,
                                                            function (channel) {
                                                              return _c(
                                                                "td",
                                                                {
                                                                  key: channel,
                                                                  staticClass:
                                                                    "text-center",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        top: "",
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "activator",
                                                                              fn: function (
                                                                                ref
                                                                              ) {
                                                                                var on =
                                                                                  ref.on
                                                                                var attrs =
                                                                                  ref.attrs
                                                                                return [
                                                                                  _c(
                                                                                    "v-chip",
                                                                                    _vm._g(
                                                                                      _vm._b(
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              "x-small":
                                                                                                "",
                                                                                              color:
                                                                                                _vm.statusColor(
                                                                                                  person.stateFor(
                                                                                                    advertiser.id,
                                                                                                    channel
                                                                                                  )
                                                                                                    .status
                                                                                                ),
                                                                                              outlined:
                                                                                                "none" ===
                                                                                                person.stateFor(
                                                                                                  advertiser.id,
                                                                                                  channel
                                                                                                )
                                                                                                  .status,
                                                                                              "text-color":
                                                                                                "none" ===
                                                                                                person.stateFor(
                                                                                                  advertiser.id,
                                                                                                  channel
                                                                                                )
                                                                                                  .status
                                                                                                  ? undefined
                                                                                                  : "white",
                                                                                              "data-cy":
                                                                                                "consent-state-" +
                                                                                                advertiser.id +
                                                                                                "-" +
                                                                                                channel,
                                                                                            },
                                                                                        },
                                                                                        "v-chip",
                                                                                        attrs,
                                                                                        false
                                                                                      ),
                                                                                      on
                                                                                    ),
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm.$t(
                                                                                            "consents.status." +
                                                                                              person.stateFor(
                                                                                                advertiser.id,
                                                                                                channel
                                                                                              )
                                                                                                .status
                                                                                          )
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.stateDetail(
                                                                                person.stateFor(
                                                                                  advertiser.id,
                                                                                  channel
                                                                                )
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-card-subtitle", { staticClass: "pb-0" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$tc(
                                        "consents.person.leads",
                                        person.leads.length,
                                        {
                                          count: person.leads.length,
                                        }
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-container",
                                  { attrs: { fluid: "" } },
                                  _vm._l(
                                    person.leads,
                                    function (lead, leadIndex) {
                                      return _c(
                                        "v-row",
                                        {
                                          key: leadIndex,
                                          attrs: { "data-cy": "consent-lead" },
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "v-sheet",
                                                {
                                                  staticClass: "pa-2",
                                                  attrs: {
                                                    outlined: "",
                                                    rounded: "",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            md: "8",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-row",
                                                            {
                                                              attrs: {
                                                                dense: true,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    sm: "2",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-caption",
                                                                    },
                                                                    [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "consents.collect.date"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    sm: "4",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-caption",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "gmtdate"
                                                                          )(
                                                                            lead
                                                                              .collect
                                                                              .createdAt
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    sm: "2",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-caption",
                                                                    },
                                                                    [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "consents.collect.campaign_type"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    sm: "4",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "text-left",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "campaign-type-component",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              campaign:
                                                                                lead
                                                                                  .collect
                                                                                  .campaign,
                                                                              small:
                                                                                "",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-row",
                                                            {
                                                              attrs: {
                                                                dense: true,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    sm: "2",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-caption",
                                                                    },
                                                                    [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "consents.collect.campaign"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    sm: "4",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-caption text-left",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "mr-1",
                                                                          attrs:
                                                                            {
                                                                              left: "",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "campaign-flag-component",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  campaign:
                                                                                    lead
                                                                                      .collect
                                                                                      .campaign,
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "mr-1",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "campaign-state-component",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  state:
                                                                                    lead
                                                                                      .collect
                                                                                      .campaign
                                                                                      .state,
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            lead
                                                                              .collect
                                                                              .campaign
                                                                              .name
                                                                          ) +
                                                                          "\n                            "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    sm: "2",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-caption",
                                                                    },
                                                                    [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "consents.collect.ip_address"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    sm: "4",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-caption",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          lead
                                                                            .collect
                                                                            .ipAddress
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-row",
                                                            {
                                                              attrs: {
                                                                dense: true,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    sm: "2",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-caption",
                                                                    },
                                                                    [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "consents.collect.support_url"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    sm: "4",
                                                                  },
                                                                },
                                                                [
                                                                  _vm.getSupportUrl(
                                                                    lead
                                                                  ).length > 0
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-caption",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "a",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  href: _vm.getSupportUrl(
                                                                                    lead
                                                                                  ),
                                                                                  target:
                                                                                    "_blank",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.getSupportUrl(
                                                                                    lead
                                                                                  )
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    sm: "2",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-caption",
                                                                    },
                                                                    [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "consents.collect.sent_at"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12",
                                                                    sm: "4",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-caption",
                                                                      attrs: {
                                                                        "data-cy":
                                                                          "consent-lead-sent-at",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          lead.sentAt
                                                                            ? _vm.formatDateTime(
                                                                                lead.sentAt
                                                                              )
                                                                            : _vm.$t(
                                                                                "consents.collect.not_sent"
                                                                              )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          lead.sentAt
                                                            ? _c(
                                                                "v-row",
                                                                {
                                                                  attrs: {
                                                                    dense: true,
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      attrs: {
                                                                        cols: "12",
                                                                        sm: "2",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-caption",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "b",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "consents.collect.at_sending"
                                                                                  )
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      attrs: {
                                                                        cols: "12",
                                                                        sm: "10",
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.sendingRows(
                                                                        lead
                                                                      ),
                                                                      function (
                                                                        row
                                                                      ) {
                                                                        return _c(
                                                                          "div",
                                                                          {
                                                                            key: row
                                                                              .advertiser
                                                                              .id,
                                                                            staticClass:
                                                                              "text-caption",
                                                                            attrs:
                                                                              {
                                                                                "data-cy":
                                                                                  "consent-lead-sending-row-" +
                                                                                  row
                                                                                    .advertiser
                                                                                    .id,
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                              " +
                                                                                _vm._s(
                                                                                  row
                                                                                    .advertiser
                                                                                    .name ||
                                                                                    "#" +
                                                                                      row
                                                                                        .advertiser
                                                                                        .id
                                                                                ) +
                                                                                "\n                              "
                                                                            ),
                                                                            row
                                                                              .channels
                                                                              .length ===
                                                                            0
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.$t(
                                                                                          "consents.collect.no_consent_at_sending"
                                                                                        )
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _vm._l(
                                                                              row.channels,
                                                                              function (
                                                                                item
                                                                              ) {
                                                                                return _c(
                                                                                  "v-chip",
                                                                                  {
                                                                                    key: item.channel,
                                                                                    staticClass:
                                                                                      "mr-1",
                                                                                    attrs:
                                                                                      {
                                                                                        "x-small":
                                                                                          "",
                                                                                        label:
                                                                                          "",
                                                                                        color:
                                                                                          _vm.statusColor(
                                                                                            item.status
                                                                                          ),
                                                                                        "text-color":
                                                                                          "white",
                                                                                        "data-cy":
                                                                                          "consent-lead-sending-" +
                                                                                          row
                                                                                            .advertiser
                                                                                            .id +
                                                                                          "-" +
                                                                                          item.channel,
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.$t(
                                                                                          "consents.channel." +
                                                                                            item.channel
                                                                                        )
                                                                                      ) +
                                                                                        "\n                                :\n                                " +
                                                                                        _vm._s(
                                                                                          _vm.$t(
                                                                                            "consents.status." +
                                                                                              item.status
                                                                                          )
                                                                                        )
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              }
                                                                            ),
                                                                          ],
                                                                          2
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      lead.collect.consents
                                                        .length > 0
                                                        ? _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "text-left fill-height",
                                                              attrs: {
                                                                cols: "12",
                                                                md: "4",
                                                              },
                                                            },
                                                            _vm._l(
                                                              lead.collect
                                                                .consents,
                                                              function (
                                                                consent
                                                              ) {
                                                                return _c(
                                                                  "v-dialog",
                                                                  {
                                                                    key: consent.url,
                                                                    attrs: {
                                                                      "max-width":
                                                                        "60%",
                                                                    },
                                                                    scopedSlots:
                                                                      _vm._u(
                                                                        [
                                                                          consent.screenshotUrl
                                                                            ? {
                                                                                key: "activator",
                                                                                fn: function (
                                                                                  ref
                                                                                ) {
                                                                                  var on =
                                                                                    ref.on
                                                                                  return [
                                                                                    _c(
                                                                                      "div",
                                                                                      _vm._g(
                                                                                        {
                                                                                          staticClass:
                                                                                            "screenshot-thumbnail",
                                                                                          class:
                                                                                            {
                                                                                              "screenshot-thumbnail--cropped":
                                                                                                _vm.isCropped(
                                                                                                  consent.screenshotUrl
                                                                                                ),
                                                                                            },
                                                                                          style:
                                                                                            _vm.thumbnailStyle(
                                                                                              consent.screenshotUrl
                                                                                            ),
                                                                                        },
                                                                                        on
                                                                                      ),
                                                                                      [
                                                                                        !_vm.isCropped(
                                                                                          consent.screenshotUrl
                                                                                        )
                                                                                          ? _c(
                                                                                              "img",
                                                                                              {
                                                                                                staticStyle:
                                                                                                  {
                                                                                                    width:
                                                                                                      "100%",
                                                                                                    height:
                                                                                                      "100%",
                                                                                                    display:
                                                                                                      "block",
                                                                                                  },
                                                                                                attrs:
                                                                                                  {
                                                                                                    src: consent.screenshotUrl,
                                                                                                  },
                                                                                              }
                                                                                            )
                                                                                          : _vm._e(),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              }
                                                                            : null,
                                                                        ],
                                                                        null,
                                                                        true
                                                                      ),
                                                                  },
                                                                  [
                                                                    _vm._v(" "),
                                                                    _c("img", {
                                                                      staticStyle:
                                                                        {
                                                                          width:
                                                                            "100%",
                                                                        },
                                                                      attrs: {
                                                                        src: consent.screenshotUrl,
                                                                      },
                                                                    }),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                ],
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }